import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useContext, useState, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import clsx from 'clsx';
import LazyPicture from '../atoms/LazyPicture';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { ReactComponent as ChevronLeftIcon } from '../../resources/icons/iconChevronLeftCollapsed.svg';
import { ReactComponent as ChevronRightIcon } from '../../resources/icons/iconChevronRightCollapsed.svg';
var CategoryDetails = function CategoryDetails(_ref) {
  var cardsProps = _ref.cardsProps,
    cardsToShow = _ref.cardsToShow,
    rtl = _ref.rtl,
    toTopTerm = _ref.toTopTerm,
    additionalRecount = _ref.additionalRecount,
    isMobile = _ref.isMobile,
    inCarousel = _ref.inCarousel,
    backToTopHandler = _ref.backToTopHandler,
    analytics = _ref.analytics;
  var eventsAnalytics = analytics.eventsAnalytics,
    params = analytics.params;
  var title = get(cardsProps, 'title.jss.value');
  var column1Title = get(cardsProps, 'columnOneTitle.jss.value', '');
  var column1Description = get(cardsProps, 'columnOneDescription.jss.value', '');
  var column1CTATitle = get(cardsProps, 'columnOneLinkText.jss.value', '');
  var column1CTALink = get(cardsProps, 'columnOneLink.jss.value.href');
  var column2Title = get(cardsProps, 'columnTwoTitle.jss.value', '');
  var column2HTML = get(cardsProps, 'columnTwoText.jss.value', '');
  var column2CTATitle = get(cardsProps, 'columnTwoLinkText.jss.value', '');
  var column2CTALink = get(cardsProps, 'columnTwoLink.jss.value.href');
  var column3Image = get(cardsProps, 'columnThreeImage.jss.value');
  var column3Title = get(cardsProps, 'columnThreeTitle.jss.value', '');
  var column3CTALink = get(cardsProps, 'columnThreeLink.jss.value.href');
  var column4Image = get(cardsProps, 'columnFourImage.jss.value');
  var column4Title = get(cardsProps, 'columnFourTitle.jss.value', '');
  var column4CTALink = get(cardsProps, 'columnFourLink.jss.value.href');
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var detailsWrapperRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    detailsHeight = _useState2[0],
    setDetailsHeight = _useState2[1];
  var countHeight = 3;
  if (canUseDOM) {
    countHeight = throttle(function () {
      if (detailsWrapperRef.current) {
        setDetailsHeight(detailsWrapperRef.current.offsetHeight);
      }
    }, 300);
  }
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(countHeight, 500);
      window.addEventListener('resize', countHeight);
    }
    return function () {
      window.removeEventListener('resize', countHeight);
    };
  }, []);
  useEffect(function () {
    if (additionalRecount && canUseDOM) {
      countHeight();
    }
  }, [additionalRecount]);
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(countHeight, 100);
    }
  }, [sitecoreContext.selectedFontSize]);
  var backToTopClickHandler = function backToTopClickHandler(e) {
    if (backToTopHandler) backToTopHandler(e);
  };
  var showColumn2 = column2Title || column2HTML || column2CTATitle;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('wc-details-visibility', {
      'wc-details-visibility--visible js--details-visible': cardsToShow.includes(cardsProps.id)
    }),
    style: {
      '--wc-details-height': "".concat(detailsHeight, "px")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc-details-border",
    ref: detailsWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg d-lg-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx('wc-details__column-1', {
      'wc-details__column-1--fullwidth': !showColumn2
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, column1Title), /*#__PURE__*/React.createElement("p", null, column1Description), column1CTATitle && column1CTALink && /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary",
    href: column1CTALink,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['subButtonClickAnalytics'], params), [title, column1CTATitle]);
    }
  }, column1CTATitle)))), showColumn2 && /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc-details__column-2"
  }, column2Title && /*#__PURE__*/React.createElement("h3", null, column2Title), column2HTML && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: column2HTML
    },
    className: "wc-details__rtf"
  }), column2CTATitle && column2CTALink && /*#__PURE__*/React.createElement("a", {
    href: column2CTALink,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['subLearnMoreAnalytics'], params), [title, column2Title, column2CTATitle]);
    }
  }, column2CTATitle, " ", rtl ? /*#__PURE__*/React.createElement(ChevronLeftIcon, null) : /*#__PURE__*/React.createElement(ChevronRightIcon, null)))), column3CTALink && /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc-details__card"
  }, /*#__PURE__*/React.createElement("a", {
    href: column3CTALink,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['subCategoryBannerClickAnalytics'], params), [title, column3Title]);
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    hover: true,
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 1441px)",
    srcSet: injectImageResolution(column3Image.src, 315, 230)
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: injectImageResolution(column3Image.src, 235, 170)
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 568px)",
    srcSet: injectImageResolution(column3Image.src, 1750, 1270)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageResolution(column3Image.src, 940, 680),
    alt: column3Image.alt
  }))), /*#__PURE__*/React.createElement("a", {
    href: column3CTALink,
    className: "wc-details__card-infolink",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['subCategoryTitleClickAnalytics'], params), [title, column3Title]);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "wc-details__card-info"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "wc-details__card-title"
  }, column3Title), /*#__PURE__*/React.createElement("span", {
    className: "spacer"
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: "icon"
  }))))), column4CTALink && /*#__PURE__*/React.createElement("div", {
    className: "col-lg-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wc-details__card"
  }, /*#__PURE__*/React.createElement("a", {
    href: column4CTALink,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['subCategoryBannerClickAnalytics'], params), [title, column4Title]);
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    hover: true,
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 1441px)",
    srcSet: injectImageResolution(column4Image.src, 315, 230)
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: injectImageResolution(column4Image.src, 235, 170)
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 568px)",
    srcSet: injectImageResolution(column4Image.src, 1750, 1270)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageResolution(column4Image.src, 940, 680),
    alt: column4Image.alt
  }))), /*#__PURE__*/React.createElement("a", {
    href: column4CTALink,
    className: "wc-details__card-infolink",
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['subCategoryTitleClickAnalytics'], params), [title, column4Title]);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "wc-details__card-info"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "wc-details__card-title"
  }, column4Title), /*#__PURE__*/React.createElement("span", {
    className: "spacer"
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeftIcon, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: "icon"
  }))))))), inCarousel && isMobile && /*#__PURE__*/React.createElement("button", {
    className: "wc-details__top-link",
    onClick: backToTopClickHandler
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, {
    className: "icon"
  }), toTopTerm)));
};
export default CategoryDetails;